export default __webpack_public_path__ + "locales/tr/DownloadDialog.json?hash=2c94acde0e0f0a20b3a4d02417984cdc";